
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useSpring, animated, config } from "@react-spring/three";

  export function VuseUltraScreen({position, type}) {
    const { nodes, materials: materialsBattery } = useGLTF('/data/screen-battery.glb')
    const { materials: materialsBluetooth } = useGLTF('/data/screen-bt.glb')
    const { materials: materialsDrop } = useGLTF('/data/screen-drop.glb')

    const types = {
        battery: materialsBattery['ekran 1'],
        bluetooth: materialsBluetooth['ekran 3'],
        drop: materialsDrop['ekran 2']
    }

    const springBattery = useSpring({opacity: type === "battery" ? 1 : 0, config: config.stiff, delay: type !== "battery" ? 100 : 0});
    const springBluetooth = useSpring({opacity: type === "bluetooth" ? 1 : 0, config: config.stiff, delay: type !== "bluetooth" ? 100 : 0});
    const springDrop = useSpring({opacity: type === "drop" ? 1 : 0, config: config.stiff, delay: type !== "drop" ? 100 : 0});

    return (
      <group position={position} dispose={null}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.vuse_ekran1.geometry}
        //   material={types[type]}
          position={[1.42, -0.996, 0]}
        >
            <animated.meshPhysicalMaterial {...types.battery} transparent opacity={springBattery.opacity}/>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.vuse_ekran1.geometry}
        //   material={types[type]}
          position={[1.42, -0.996, 0]}
        >
            <animated.meshPhysicalMaterial {...types.bluetooth} transparent opacity={springBluetooth.opacity}/>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.vuse_ekran1.geometry}
        //   material={types[type]}
          position={[1.42, -0.996, 0]}
        >
            <animated.meshPhysicalMaterial {...types.drop} transparent opacity={springDrop.opacity}/>
        </mesh>
      </group>
    )
  }